// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__P6ZwD","buttons":"PendingPaymentAlert_buttons__19kj-"};